import React, { Component } from 'react';
import { connect } from 'react-redux';
import { popupDispatcher, cartState, currentNodeState, identityState, combineStates, siteSettingsState, screenSizeState, showConfigureState } from '../../../store';
import { SvgImage, Search, CartSummaryMenu } from '../../../components';
import { translate } from '../../../services';
import PropTypes from 'prop-types';
import { arrowLeftIcon, uploadIcon } from '../../../../style/images';
import { Breadcrumb, BreadcrumbChildSelector } from '.';
import classNames from 'classnames';
import { Box } from '@mui/material';
import { calculateWordDimensions } from '../../../util';

function getPathToRoot( node ) {
  return !node.parent ? [node] : [node].concat( getPathToRoot( node.parent ) );
}

export const routeMap = {
  configuratorselector: { title: 'Categories', showCategory: true },
  selector: { title: 'Categories', showCategory: true },
  categories: { title: 'Categories', showCategory: true },
  cart: { title: 'Cart', showCategory: false },
  configurator: { title: 'Configurator', showCategory: true },
  home: { title: 'Home', showCategory: false },
};

export class BreadcrumbHeaderComponent extends Component {
  
  shouldComponentUpdate(){
    if(this.props.showConfigure.show){
      return false
    }
    return true;
  }
  renderPage() {
    const { currentNode, pathname, screenSize } = this.props;
    const path = pathname.split( '/' )[1].toLowerCase() || 'home';
    const currentPage = routeMap[path];
    
    if ( currentPage && currentNode ) {
      if ( !currentPage.showCategory ) {
        return currentPage.title === 'Home'
          ? null
          : <li>{ translate( currentPage.title ) }</li>;
      }
      const pathParts = getPathToRoot( currentNode ).reverse();

      let childSelector = null;
      let totalWidth = 0;
      let maxWidth = screenSize.width;
      if(pathParts.length>2){
        let firstChild = translate(pathParts[pathParts.length-1].name);
        let secondChild = translate(pathParts[pathParts.length-2].name);
        totalWidth = calculateWordDimensions(firstChild).width+calculateWordDimensions(secondChild).width

        let index = pathParts.length-3;
        if(totalWidth>=maxWidth-70){
          index = pathParts.length-2
        }
        const node = pathParts[index];
        const child= pathParts.length > index + 1 ? pathParts[index + 1] : null 
        const children = node.children || [];
        childSelector = !children.length || !child ? null : <BreadcrumbChildSelector current={ child } children={ children } />;
      }
      
      const component = <>
        <Box sx={{display:{md:"none", xs:"flex"}, flexDirection:"row", gap:{md:"4px", xs:"0px"}}}>
        {pathParts.length>2&&<>
          <span className='dots'>...</span>
          {childSelector}
        </>}
        <>{totalWidth>=maxWidth-70?
        <>{pathParts.slice(pathParts.length-1).map( ( pathPart, index ) => <Breadcrumb
            key={ index }
            isLast={ true }
            node={ pathPart }
            child={ pathParts.length > index + 1 ? pathParts[index + 1] : null }
          />)}</>:<>{pathParts.slice(pathParts.length-2).map( ( pathPart, index ) => <Breadcrumb
        key={ index }
        isLast={ index === 1 }
        node={ pathPart }
        child={ pathParts.length > index + 1 ? pathParts[index + 1] : null }
      />
      )}</>}</></Box>
      <Box sx={{display:{md:"flex", xs:"none"}, gap:{md:"8px", xs:"none"}}}>
        {pathParts.map( ( pathPart, index ) => <Breadcrumb
          key={ index }
          isLast={ index === pathParts.length - 1 }
          node={ pathPart }
          child={ pathParts.length > index + 1 ? pathParts[index + 1] : null }
          singleNode = {pathParts.length===1}
        />
        )}
      </Box>
      </>
      return component
    }
    return null;
  }

  onBack = () => {
    this.props.onBack && this.props.onBack();
    window.history.back();
  }

  getBackButton() {
    const { setBack } = this.props;
    return !setBack ? null : <div className="back-button" onClick={ this.onBack } title={ translate( 'Go back' ) }>
      <SvgImage source={ arrowLeftIcon } />
      <span>{ translate( 'Back' ) }</span>
    </div>;
  }
  render() {
    const {cart, isIntegrated, user } = this.props;
    console.log(this.props.setBack)
    // const searchString = this.context.router.route.location.pathname.split( '/search/' )[1] || '';
    const searchString ='';
    const { currentNode, pathname } = this.props;
    const pathParts = getPathToRoot( currentNode ).reverse();
    return<>{!this.props.fromMobileHeader?<Box width="100%" height="100%" sx={{display:{md:"flex", xs:!this.props.mobileTileView?"flex":pathParts.length>1?"flex":"none"}}}>
      <div className={ !this.props.mobileView?classNames( 'breadcrumb-header', { 'integrated': isIntegrated } ): classNames( 'breadcrumb-header-mobileHeader', { 'integrated': isIntegrated } )}>
      <div className="breadcrumb-header-left">
        { this.getBackButton() }
        <ul>
          {this.renderPage()}
        </ul>
      </div>
     </div></Box>:<div className='mobile-header-breadcrumb-container'>
        {pathParts.length===1?<span className='mobile-header-breadcrumb'>
          {translate("Categories")}
        </span>:<>{ this.getBackButton() }</>}
      </div>}
     </>;
  }
}

BreadcrumbHeaderComponent.propTypes = {
  currentNode: PropTypes.shape( {} ),
  isIntegrated: PropTypes.bool,
  onBack: PropTypes.func,
  setBack: PropTypes.bool,
  showNavigation: PropTypes.bool,
  setPopup: PropTypes.func.isRequired,
  siteSettings: PropTypes.shape( {
    showUserMenu: PropTypes.bool.isRequired
  } ),
  user: PropTypes.shape( {
    hasCart: PropTypes.bool.isRequired,
    useLocalCart: PropTypes.bool.isRequired
  } )
};

BreadcrumbHeaderComponent.contextTypes = {
  router: PropTypes.object.isRequired
};

export const BreadcrumbHeader = connect( combineStates( cartState,currentNodeState,screenSizeState,showConfigureState, identityState, siteSettingsState ),popupDispatcher )( BreadcrumbHeaderComponent );